import { createContext, useContext } from 'react';
import { Editor } from '@meitu/saas-editor-core';

export const EditorContext = createContext<Editor | null>(null);

// 添加一个自定义 hook 方便子组件使用
export const useEditor = () => {
    const editor = useContext(EditorContext);
    if (!editor) {
        throw new Error('useEditor must be used within an EditorContext.Provider');
    }
    return editor;
};
